export const NAME = 'ALCHEMY';
export const SCROLL_SAVE_DELAY = 1000;
export const LERP_ALPHA = 0.1;
export const SCROLL_PERC_PRECISION = 5;
export const SCROLL_TOP_PRECISION = 0.000001;
export const SCROLL_TIME_FLOAT_PRECISION = 3;
export const SET_ORCHESTRATOR = Symbol('orchestrator.set');